import { compose, mapProps, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import withFocusFirstInput from 'components/common/hoc/withFocusFirstInput'
import toggle from 'components/common/hoc/toggle'
import { convertStatesToOptions } from 'helpers/options'
import { formatPhoneNumber } from 'helpers/phone-number'
import PersonalInformationDrawer from './PersonalInformationDrawer'
import {
  getPersonalInformationFormInitialValues,
  getFullAddress,
  getFullName,
  getBirthday
} from './helpers'
import { NONE } from '../../constants'
import { submitPersonalInformation } from './actions'

const withViewData = mapProps(({ accountContactDetails, states, ...props }) => ({
  ...props,
  accountContactDetails,
  formInitialValues: getPersonalInformationFormInitialValues(accountContactDetails),
  fullUserName: getFullName(accountContactDetails, NONE),
  fullUserAddress: getFullAddress(accountContactDetails, NONE),
  userBirthday: getBirthday(accountContactDetails, NONE),
  stateOptions: convertStatesToOptions(states),
  primaryPhone: formatPhoneNumber(accountContactDetails.primaryPhone, NONE),
  alternatePhone: formatPhoneNumber(accountContactDetails.alternatePhone, NONE)
}))

const withHandleUpdatePersonalInformation = withHandlers({
  handleUpdatePersonalInformation: ({ submitPersonalInformation }) => values => submitPersonalInformation(values)
})

export default compose(
  connect(null, { submitPersonalInformation }),
  toggle,
  withFocusFirstInput,
  withViewData,
  withHandleUpdatePersonalInformation
)(PersonalInformationDrawer)
